/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { connect } from 'react-redux';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ReportTableContainer from 'reports/Common/ReportTable';
import { convertStylistCategoryToCategoryRevenueTableData } from 'reports/utils';

class CategoryRevenueTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const currencyAbbr = this.props.currency;
    return (
      <div id="revenue-category">
        <ReportTableContainer
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          title="Revenue by Category"
          data={{
            rows: convertStylistCategoryToCategoryRevenueTableData(
              this.props.dataCategory,
              this.props.dataProducts,
              this.props.stylists.filter((s) => s.total_revenue !== 0),
              currencyAbbr,
            ),
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currency: selectCurrentSalonCurrency(state),
});

const CategoryRevenueTableHoc = connect(mapStateToProps)(CategoryRevenueTable);

export default CategoryRevenueTableHoc;
